module.exports = __webpack_public_path__ + "img/202102.d131d197.png";